import React, { useState } from 'react'
import Breadcumb from '../Breadcumb/Main';
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from 'react-i18next';

const Contact = () => {
  const { t } = useTranslation();
  
  // Form state
  const [formData, setFormData] = useState({
    // Basic Info
    name: "",
    email: "",
    phone: "",
    company: "",
    position: "",
    website: "",
    
    // Project Details
    projectTitle: "",
    projectDescription: "",
    budget: "",
    timeline: "",
    
    // Services - Store KEYS not labels
    services: [],
    industries: [],
    
    // Additional Requirements
    teamSize: "",
    projectType: "",
    technologies: "",
    additionalNotes: ""
  });
  
  const [emailError, setEmailError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Service options - ONLY KEYS (matching your translation structure)
  const serviceOptions = [
    "web_application",
    "mobile_app",
    "frontend_development",
    "cloud_devOps",
    "chatbot_development",
    "big_data",
    "qa_testing",
    "cloud_integration",
    "it_metrics_and_dashboard",
    "cyber_security",
    "it_consultant",
    "hire_development",
    "microsoft",
    "iot",
    "ar_vr",
    "business_technology",
    "product_prototype",
    "managed_services",
    "enterprise_mobility"
  ];

  // Industry options - ONLY KEYS (matching your translation structure)
  const industryOptions = [
    "healthcare",
    "education_e_learning",
    "social_network",
    "retail",
    "manufacturing",
    "e_commerce",
    "energy",
    "travel_hospitality",
    "real_estate",
    "media_entertainment",
    "logistics_distribution",
    "construction"
  ];

  const budgetRanges = [
    "Under $5,000",
    "$5,000 - $15,000",
    "$15,000 - $50,000",
    "$50,000 - $100,000",
    "$100,000 - $250,000",
    "$250,000+",
    "Let's Discuss"
  ];

  const timelineOptions = [
    "ASAP (Rush)",
    "1-2 months",
    "3-6 months",
    "6-12 months",
    "12+ months",
    "Flexible"
  ];

  const teamSizeOptions = [
    "1-2 developers",
    "3-5 developers",
    "6-10 developers",
    "10+ developers",
    "Full team (developers, designers, PM)",
    "Not sure"
  ];

  const projectTypes = [
    "New Project",
    "Existing Project Enhancement",
    "Maintenance & Support",
    "Consultation Only",
    "Staff Augmentation"
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Modified to use KEYS instead of labels
  const handleCheckboxChange = (category, key) => {
    setFormData(prev => ({
      ...prev,
      [category]: prev[category].includes(key)
        ? prev[category].filter(item => item !== key)
        : [...prev[category], key]
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    
    // Validation - only required fields
    if (!formData.name.trim() || !formData.email.trim() || !formData.phone.trim() || !formData.position.trim() || !formData.projectDescription.trim()) {
      toast.error(t('contact_page.validation_error'), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }

    if (emailError) {
      toast.error(t('contact_page.email_validation_error'), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }

    setIsSubmitting(true);

    // Prepare email data - Convert keys to translated text
    const emailData = {
      client_name: formData.name,
      client_email: formData.email,
      client_phone: formData.phone,
      company_name: formData.company,
      client_position: formData.position,
      client_website: formData.website,
      project_title: formData.projectTitle,
      project_description: formData.projectDescription,
      budget_range: formData.budget,
      timeline: formData.timeline,
      // Convert service keys to translated text for email - FIXED PATH
      services_required: formData.services.map(key => t(`contact_page.services_${key}`)).join(", "),
      target_industries: formData.industries.map(key => t(`contact_page.industries_${key}`)).join(", "),
      team_size: formData.teamSize,
      project_type: formData.projectType,
      preferred_technologies: formData.technologies,
      additional_notes: formData.additionalNotes,
      submission_date: new Date().toLocaleDateString(),
      submission_time: new Date().toLocaleTimeString()
    };

    emailjs.send("service_unti0lw", "template_41vm71w", emailData, '_zwXqYv2_kdBz2ZfX')
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        toast.success(t('contact_page.success_message'), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        
        // Clear form
        setFormData({
          name: "",
          email: "",
          phone: "",
          company: "",
          position: "",
          website: "",
          projectTitle: "",
          projectDescription: "",
          budget: "",
          timeline: "",
          services: [],
          industries: [],
          teamSize: "",
          projectType: "",
          technologies: "",
          additionalNotes: ""
        });
        setIsSubmitting(false);
      })
      .catch((error) => {
        console.error('FAILED...', error);
        toast.error(t('contact_page.error_message'), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setIsSubmitting(false);
      });
  };

  const handleWebsiteBlur = (e) => {
    let value = e.target.value.trim();
    if (value && !/^https?:\/\//i.test(value)) {
      value = 'https://' + value;
      setFormData(prev => ({ ...prev, website: value }));
    }
  };

  const handleEmail = (e) => {
    setEmailError(false);
    const value = e.target.value;
    
    // Basic email validation only
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (value && !emailRegex.test(value)) {
      setEmailError(true);
    }
    
    // Remove domain restriction - accept all domains
    setFormData(prev => ({ ...prev, email: value }));
  };

  return (
    <>
      <ToastContainer />
      <Breadcumb Title={t('contact_page.contact_us')} Breadcumb={t('breadcrumb.contact')} />
      <section className="contact-one section-padding--top section-padding--bottom">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <form
                className="contact-one__form contact-form-validated"
                name="contact"
                onSubmit={handleSubmit}>
                <div className="section-title">
                  <p className="section-title__text">{t('contact_page.contact_us')}</p>
                  <h2 className="section-title__title">
                    {t('contact_page.join_us')}
                  </h2>
                </div>

                {/* Basic Information */}
                <div className="row">
                  <div className="col-12">
                    <h4 className="form-section-title">{t('contact_page.client_info')}</h4>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <input
                      type="text"
                      placeholder={t('contact_page.full_name')}
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <input
                      className={emailError ? 'danger-border' : 'cool-border'}
                      type="email"
                      placeholder={t('contact_page.email_address')}
                      name="email"
                      value={formData.email}
                      onChange={handleEmail}
                      required
                    />
                    {emailError && (
                      <span className="red">{t('contact_page.mail_error')}</span>
                    )}
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <input
                      type="tel"
                      placeholder={t('contact_page.phone_number')}
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <input
                      type="text"
                      placeholder={t('contact_page.company_name')}
                      name="company"
                      value={formData.company}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <input
                      type="text"
                      placeholder={t('contact_page.position_role')}
                      name="position"
                      value={formData.position}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <input
                      type="text"
                      placeholder={t('contact_page.company_website')}
                      name="website"
                      value={formData.website}
                      onChange={handleInputChange}
                      onBlur={handleWebsiteBlur}
                    />
                  </div>
                </div>

                {/* Project Information */}
                <div className="row mt-4">
                  <div className="col-12">
                    <h4 className="form-section-title">{t('contact_page.project_details')}</h4>
                  </div>
                  <div className="col-lg-12 col-md-12">
                    <input
                      type="text"
                      placeholder={t('contact_page.project_title')}
                      name="projectTitle"
                      value={formData.projectTitle}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-lg-12 col-md-12">
                    <textarea
                      name="projectDescription"
                      placeholder={t('contact_page.project_description')}
                      value={formData.projectDescription}
                      onChange={handleInputChange}
                      required
                      rows="5"
                    />
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <select
                      name="budget"
                      value={formData.budget}
                      onChange={handleInputChange}
                    >
                      <option value="">{t('contact_page.select_budget')}</option>
                      {budgetRanges.map(budget => (
                        <option key={budget} value={budget}>{budget}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <select
                      name="timeline"
                      value={formData.timeline}
                      onChange={handleInputChange}
                    >
                      <option value="">{t('contact_page.select_timeline')}</option>
                      {timelineOptions.map(timeline => (
                        <option key={timeline} value={timeline}>{timeline}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <select
                      name="projectType"
                      value={formData.projectType}
                      onChange={handleInputChange}
                    >
                      <option value="">{t('contact_page.select_project_type')}</option>
                      {projectTypes.map(type => (
                        <option key={type} value={type}>{type}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <select
                      name="teamSize"
                      value={formData.teamSize}
                      onChange={handleInputChange}
                    >
                      <option value="">{t('contact_page.select_team_size')}</option>
                      {teamSizeOptions.map(size => (
                        <option key={size} value={size}>{size}</option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Services Required - FIXED VERSION */}
                <div className="row mt-4">
                  <div className="col-12">
                    <h4 className="form-section-title">{t('contact_page.services_required')}</h4>
                    <p className="text-muted">{t('contact_page.select_services_desc')}</p>
                  </div>
                  <div className="col-12">
                    <div className="services-grid">
                      {serviceOptions.map(serviceKey => (
                        <div key={serviceKey} className="service-item">
                          <input
                            type="checkbox"
                            id={serviceKey}
                            checked={formData.services.includes(serviceKey)}
                            onChange={() => handleCheckboxChange('services', serviceKey)}
                          />
                          <label htmlFor={serviceKey}>{t(`contact_page.services_${serviceKey}`)}</label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Target Industries - FIXED VERSION */}
                <div className="row mt-4">
                  <div className="col-12">
                    <h4 className="form-section-title">{t('contact_page.target_industry')}</h4>
                    <p className="text-muted">{t('contact_page.select_industries_desc')}</p>
                  </div>
                  <div className="col-12">
                    <div className="services-grid">
                      {industryOptions.map(industryKey => (
                        <div key={industryKey} className="service-item">
                          <input
                            type="checkbox"
                            id={industryKey}
                            checked={formData.industries.includes(industryKey)}
                            onChange={() => handleCheckboxChange('industries', industryKey)}
                          />
                          <label htmlFor={industryKey}>{t(`contact_page.industries_${industryKey}`)}</label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Additional Information */}
                <div className="row mt-4">
                  <div className="col-12">
                    <h4 className="form-section-title">{t('contact_page.additional_info')}</h4>
                  </div>
                  <div className="col-lg-12 col-md-12">
                    <input
                      type="text"
                      placeholder={t('contact_page.preferred_technologies')}
                      name="technologies"
                      value={formData.technologies}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-lg-12 col-md-12">
                    <textarea
                      name="additionalNotes"
                      placeholder={t('contact_page.additional_notes')}
                      value={formData.additionalNotes}
                      onChange={handleInputChange}
                      rows="4"
                    />
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-md-12">
                    <button
                      className="thm-btn contact-one__btn"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      <span>
                        {isSubmitting ? t('contact_page.submitting') : t('contact_page.send_msg')}
                      </span>
                    </button>
                  </div>
                </div>
              </form>
              <div className="result"></div>
            </div>
          </div>
        </div>
      </section>

      <div className="row">
        <div className="col-lg-6">
          <section className="google-map google-map--contact">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3199.9758878561133!2d2.8811111764785364!3d36.67508077228305!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x128fa5f124fa6ea3%3A0x84118226c40f65d3!2sLPP%20Q10%20Mahelma!5e0!3m2!1sen!2sin!4v1716396424548!5m2!1sen!2sin"
              className="google-map__one"
              title="Algeria office"
              allowFullScreen
            />
          </section>
        </div>
        <div className="col-lg-6">
          <section className="google-map google-map--contact">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2508.230273283889!2d-114.0714057842221!3d51.048835751948026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53716ffb78be402f%3A0xbb200f05293c944a!2sCalgary%20Place%2C%20330%205%20Ave%20SW%20%231800%2C%20Calgary%2C%20AB%20T2P%200L3%2C%20Canada!5e0!3m2!1sen!2sin!4v1679908967488!5m2!1sen!2sin"
              className="google-map__one"
              title="Canada office"
              allowFullScreen
            ></iframe>
          </section>
        </div>
      </div>

      <style jsx>{`
        .form-section-title {
          color: #333;
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 2px solid #007bff;
          font-weight: 600;
        }
        
        .checkbox-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 10px;
          margin-bottom: 20px;
        }
        
        .services-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: 8px;
          margin-bottom: 20px;
        }
        
        .checkbox-item {
          display: flex;
          align-items: center;
          padding: 8px;
          border: 1px solid #e0e0e0;
          border-radius: 4px;
          background-color: #f9f9f9;
        }
        
        .service-item {
          display: flex;
          align-items: center;
          padding: 8px 12px;
          border: 2px solid #e0e0e0;
          border-radius: 25px;
          background-color: #f8f9fa;
          font-size: 14px;
          transition: all 0.3s ease;
          cursor: pointer;
          margin-bottom: 5px;
          min-height: 44px;
        }
        
        .service-item:hover {
          background-color: #e3f2fd;
          border-color: #2196f3;
          transform: translateY(-2px);
          box-shadow: 0 2px 8px rgba(33, 150, 243, 0.2);
        }
        
        .service-item input[type="checkbox"] {
          margin-right: 10px;
          width: 16px;
          height: 16px;
          accent-color: #2196f3;
          cursor: pointer;
          flex-shrink: 0;
          margin-top: 0;
          margin-bottom: 0;
          vertical-align: middle;
        }
        
        .service-item label {
          margin: 0;
          font-weight: 500;
          cursor: pointer;
          flex: 1;
          color: #333;
          line-height: 1.4;
          display: flex;
          align-items: center;
        }
        
        .service-item input[type="checkbox"]:checked ~ label,
        .service-item:has(input[type="checkbox"]:checked) label {
          color: #1976d2;
          font-weight: 600;
        }
        
        .service-item:has(input[type="checkbox"]:checked) {
          background-color: #e3f2fd;
          border-color: #2196f3;
          box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);
        }
        
        .checkbox-item input[type="checkbox"] {
          margin-right: 8px;
          transform: scale(1.1);
        }
        
        .checkbox-item label {
          margin: 0;
          font-weight: 500;
          cursor: pointer;
          flex: 1;
        }
        
        .checkbox-item:hover {
          background-color: #f0f0f0;
        }
        
        .text-muted {
          color: #666;
          font-size: 0.9em;
          margin-bottom: 15px;
        }
        
        select, input, textarea {
          width: 100%;
          padding: 12px;
          margin-bottom: 15px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 16px;
        }
        
        select:focus, input:focus, textarea:focus {
          outline: none;
          border-color: #007bff;
          box-shadow: 0 0 0 2px rgba(0,123,255,.25);
        }
        
        .danger-border {
          border-color: #dc3545 !important;
        }
        
        .red {
          color: #dc3545;
          font-size: 0.875em;
          margin-top: 5px;
        }
      `}</style>
    </>
  );
}

export default Contact